import AppData from "../const/app_data";
import EventManager from "../../../manager/event_manager";



const { ccclass, property, menu} = cc._decorator;

enum AdaptationType {
    LetfOffset = 0,
    RightOffset = 1,
    LessenX = 2,
}

@ccclass
@menu('UI/ScreenAdaptationUtil')
export default class screenAdaptationUtil extends cc.Component {
    @property({ type: cc.Enum(AdaptationType) })
    adaptationStyle: AdaptationType = AdaptationType.LetfOffset;

    @property(cc.Float)
    adaptationValue : number = 50

    widget : cc.Widget

    widgetLeft

    onLoad(){
        if (this.node) {
            this.widget = this.node.getComponent(cc.Widget)
            if (this.widget) {
                this.widgetLeft = this.widget.left
            }
        }
        this.adaptation()
    }

    start() {
        // this.adaptation()
        // EventManager.instance.off("refresh_screenAdaptationUtil", this.refresh_screenAdaptationUtil);
        // EventManager.instance.on("refresh_screenAdaptationUtil", this.refresh_screenAdaptationUtil, this)
    }

    onDestroy() {
        // EventManager.instance.off("refresh_screenAdaptationUtil", this.refresh_screenAdaptationUtil);
    }

    private refresh_screenAdaptationUtil(data) {
        if (!this || !this.node) {
            return
        }

        if (this.node.parent && this.node.parent.name) {
            let viewName = this.node.parent.name
            if (viewName != "hall_match") {
                return
            }
            if (!AppData.isWidescreen) {
                return
            }
            this.changePos(data)
        }
    }

    private changePos(data) {


        let widget = this.node.getComponent(cc.Widget)

        let offset = AppData.widescreenOffset//偏移齐刘海宽度

        let value = data.value

        if (value == "portrait") {
            //竖屏
        } else if (value == "landscape") {
            //横屏正方向，以 HOME 键在屏幕右侧为正方向
            //改变比赛场左偏移
            widget.left = this.widgetLeft + offset
        } else if (value == "landscapeReverse") {
            //横屏反方向，以 HOME 键在屏幕左侧为反方向
            //比赛场左偏移取消
            widget.left = this.widgetLeft
        }
    }

    adaptation() {
        if (!AppData.isWidescreen) {
            return
        }

        // let letfOffset = DesignWidth * (44 / 812)//偏移齐刘海宽度
        // let rightOffset = DesignWidth * (34 / 812)//偏移下面圆弧宽度
        let offset = AppData.widescreenOffset//偏移齐刘海宽度
        if (this.adaptationValue != 0) {
            offset = this.adaptationValue
        }

        switch (this.adaptationStyle) {
            case AdaptationType.LetfOffset:
                if (this.widget == null) {
                    this.node.position = cc.v2(this.node.position.x + offset, this.node.position.y)
                } else if (this.widget.isAlignLeft) {
                    this.widget.left = this.widget.left + offset
                }
                break;
            case AdaptationType.RightOffset:
                if (this.widget == null) {
                    this.node.position = cc.v2(this.node.position.x - offset, this.node.position.y)
                } else if (this.widget.isAlignRight) {
                    this.widget.right = this.widget.right + offset
                }
                break;
            case AdaptationType.LessenX:
                this.node.scaleX = 0.9
            default:
                break;
        }
    }
}
